
const style = new CSSStyleSheet
style.replaceSync(`:host {
  bottom: 0;
  display: flex;
  flex-direction: column-reverse;
  position: fixed;
  z-index: 1;
}

.notification {
  border-radius: 4px;
  font-size: 1em;
  margin-bottom: 1em;
  opacity: 0.9;
  padding: 1em 1.5em;
  width: 40ch;
}

.close {
  border: none;
  color: black;
  float: right;
  font-size: 1.5em;
  font-weight: 700;
  line-height: 1;
  opacity: 0.7;
  text-shadow: 0 1px 0 black
}

.close:hover {
    cursor: pointer;
  }

.info {
  background-color: #7CE4FE;
}

.info .close {
  background-color: #4ddbff;
}

.success {
  background-color: #8EF3C5;
}

.success .close {
  background-color: #5fedad;
}

.warning {
  background-color: #FFE28C;
}

.warning .close {
  background-color: #ffd65c;
}

.danger {
  background-color: #FF8F5E;
}

.danger .close {
  background-color: #ff6d2e;
}

/*# sourceMappingURL=to.css.map */`)



export default style
